let _ = require('lodash');
let jsonData = require('../../assets/data_sets/word_list.json');

export const getNeighborhoods = (neighborhoodList, limit = 50) => {
	let results = _.pickBy(JSON.parse(jsonData), (v, k) => {
		return neighborhoodList.indexOf(k) > -1;
	});
	return convertToListNodes(results, limit);
};

const convertToListNodes = (wordSet, limit) => {
	let links = []
	let nodes = {}

	Object.keys(wordSet).forEach( neighborhood => {
		  let sortedList = [];
		  for (let word in wordSet[neighborhood]) {
		  	sortedList.push([word, wordSet[neighborhood][word]])
		  }

		  sortedList.sort(
	    	function(a, b) {
	        return b[1] - a[1]
	    	}
			)

		let neighborhoodCount = wordSet[neighborhood][neighborhood]
		for(let i = 0; i < limit; i++) {
			let word = sortedList[i][0];
			let count = sortedList[i][1];

			nodes[word] = updateNodes(
				(nodes[word]|| {}), 
				word, 
				count, 
				neighborhood, 
				neighborhoodCount)

			if (word !== neighborhood) {
				links.push({source: word, target: neighborhood, count: count}) 
			}
		}
	});
	return {nodes: _.values(nodes), links: links}
};

let updateNodes = (node, word, count, neighborhood, nCount) => {
	let newCount = (node["count"] || 0) + count;
	let newWord = (node["id"] || word);
	let newNeighborhood = { [`${neighborhood}`]: count / nCount }
	let isNeighborhood = (word === neighborhood)

	return { count: newCount, 
			id: newWord, 
			neighborhood: newNeighborhood, 
			isNeighborhood: isNeighborhood
		} 
}

export const getListOfNeighborhoods = () => {
	return Object.keys(JSON.parse(jsonData));
}



// WEBPACK FOOTER //
// ./lib/utils/analyze_data.js